enum GigPageTab {
  Activity,
  Liked,
  CreateGig,
  History,
}

enum CreateGigTab {
  CategoryTab,
  LocationTab,
  DataTab,
  PublicDetailsTab,
  StyleAndTypeTab,
  ExtraInformationTab,
}

enum CreateGigPageState {
  New,
  Edit,
}

export { CreateGigPageState, CreateGigTab, GigPageTab };
